<template>
  <MessageView
    title="No Issues Found"
    message="There are no issues found for the given vessel and date range."
  />
</template>


  <script>
import MessageView from "./components/MessageView.vue";
export default {
  components: { MessageView },
  name: "EmptyView",
};
</script>
  
  
  